import { storefrontInventoryServicesHttpClient } from '../../utils/HttpClient'
export interface InventoryResponce {
  available: number
  locationId: number
  inventoryType: string
  tags: {
    preOrderShippingDate: string
  } | null
  vendorCode: string
  isInventoryPresentAtSFWarehouse?: boolean
}

export async function getInventory(params: Record<string, any>) {
  try {
    const { data } = await storefrontInventoryServicesHttpClient.get('/active-inventory', {
      params,
    })
    return data
  } catch (e) {
    console.error('Failed while fetching getInventory(), API - `/carts/${cartId}`', e)
    if (e?.toString() === 'AxiosError: Network Error' && e.code === 'ERR_NETWORK') return { isCorsError: true }
    return {}
  }
}
